import { GlobalNavigationContainer } from './global-navigation/GlobalNavigationContainer'
import { Outlet, ScrollRestoration } from 'react-router'
import { observer } from 'mobx-react-lite'
import { Suspense, useCallback, useState } from 'react'
import {
  NoticeBanner,
  NoticeBannerCloseButton,
  NoticeBannerText,
} from '@/features/shell/notice-banner/NoticeBanner'
import { LoadingPage } from '@/components/LoadingPage'
import { useElementSize } from '@/hooks/element-hooks'
import { PageTopOffsetContext } from '@/contexts/page-top-offset-context'
import { TermsOfUseAcceptanceDialogContainer } from '@/features/account/terms/TermsOfUseAcceptanceDialog/TermsOfUseAcceptanceDialogContainer'
import { DocumentDialogsHost } from '@/features/docs/DocumentDialogsHost'
import { TaxProfileDialogsHost } from '@/features/tax-profile/TaxProfileDialogsHost'
import { JobDialogsHost } from '@/features/jobs/JobDialogsHost'
import { HandoffDialogContainer } from '@/features/shell/handoff/HandoffDialog/HandoffDialogContainer'
import { Section7216AcceptanceDialogContainer } from '@/features/account/section-7216/Section7216AcceptanceDialog/Section7216AcceptanceDialogContainer'
import { useTranslate } from '@/hooks/translate'

/**
 * The ShellContainer
 */
export default observer(function ShellContainer() {
  const T = useTranslate()
  const announcement = T('Web.Announcement', '')
  const [isAnnouncementClosed, setIsAnnouncementClosed] = useState(false)
  const closeAnnouncement = useCallback(() => setIsAnnouncementClosed(true), [])
  const isShowingAnnouncement = !!announcement && !isAnnouncementClosed

  const { connectRef: connectAnnouncementRef, size: announcementSize } =
    useElementSize()

  const pageTopOffset = announcementSize.height
  return (
    <GlobalNavigationContainer>
      {/* For now this just resets the scroll position on navigation */}
      <ScrollRestoration />

      {isShowingAnnouncement && (
        <NoticeBanner ref={connectAnnouncementRef}>
          <NoticeBannerText>{announcement}</NoticeBannerText>
          <NoticeBannerCloseButton onPress={closeAnnouncement} />
        </NoticeBanner>
      )}

      <PageTopOffsetContext value={pageTopOffset}>
        <Suspense fallback={<LoadingPage full />}>
          <Outlet />
        </Suspense>

        <Suspense fallback={<></>}>
          <HandoffDialogContainer />
          <TermsOfUseAcceptanceDialogContainer />
          <Section7216AcceptanceDialogContainer />
          <DocumentDialogsHost />
          <TaxProfileDialogsHost />
          <JobDialogsHost />
        </Suspense>
      </PageTopOffsetContext>
    </GlobalNavigationContainer>
  )
})
